module.exports = __webpack_public_path__ + "static/media/cypress.30604990.svg";